import React, { useState } from 'react'
import * as Comp from './card-category.styles'
import { CardCategoryIcon } from './components/card-category-icon'
import { CardCategoryLabel } from './components/card-category-label'
import type { TCardCategoryProps } from './types'

const CardCategoryRoot = ({
  orientation = 'horizontal',
  onPress,
  disabled = false,
  children,
  testID,
}: TCardCategoryProps) => {
  const [pressed, setPressed] = useState(false)

  const renderInternalLabel = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === CardCategoryLabel) {
      return React.cloneElement(
        child as React.ReactElement<TCardCategoryProps>,
        {
          orientation,
          disabled,
        }
      )
    }
  })

  const renderInternalIcon = React.Children.map(children, child => {
    if (!React.isValidElement(child)) return

    if (React.isValidElement(child) && child.type === CardCategoryIcon) {
      return React.cloneElement(
        child as React.ReactElement<TCardCategoryProps & { pressed: boolean }>,
        {
          pressed,
          disabled,
          orientation,
        }
      )
    }
  })

  const componentProperties = {
    orientation,
    hasPressed: pressed,
    hasDisabled: disabled,
    hasInternalLabel: !!renderInternalLabel?.length,
  }

  return (
    <Comp.Root
      testID={testID}
      disabled={disabled}
      onPress={() => {
        if (typeof onPress === 'function') {
          onPress()
        }
      }}
      onPressIn={() => setPressed(true)}
      onPressOut={() => setPressed(false)}
      {...componentProperties}
    >
      {renderInternalIcon}
      {renderInternalLabel}
    </Comp.Root>
  )
}

export const CardCategory = {
  Root: CardCategoryRoot,
  Label: CardCategoryLabel,
  Icon: CardCategoryIcon,
}

export type { TCardCategoryProps }
